import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ModalRef, ModalService } from '@common/services/modal.service';

@Component({
  templateUrl: './confirmer.component.html',
  styleUrls: ['./confirmer.component.scss']
})
export class ConfirmerComponent implements OnInit {
  

  @Input()
  public products: { sku: string, colors: string[], price: number, fee: number, profit: number }[]

  @Output()
  public onConfirm = new EventEmitter();

  @Output()
  public onCancel = new EventEmitter();

  constructor(private modal: ModalService) { }

  ngOnInit(): void {
  }

  public confirm() {
    this.modal.of(this).hide();
    this.onConfirm.emit();
  }

  public cancel() {
    this.modal.of(this).hide();
    this.onCancel.emit();
  }
}
